import { watch } from 'vue';
import store from "@/store";

export class Api
{
  apiHost = process.env.VUE_APP_API_HOST;
  externalApiHost = process.env.VUE_APP_EXTERNAL_API_HOST;
  debug = false;

  constructor() {
    this.debug = process.env.VUE_APP_ENV === 'dev';
  }

  $http(config = {}) {
    if (this.debug) console.log('[api] url: ', config.url);
    
    if (config?.data && typeof config.data === 'object') config.data = JSON.stringify(config.data);
    if (config?.body && typeof config.body === 'object') config.body = JSON.stringify(config.body);

    if (store.state.qcssoSdk === null)
    {
      return new Promise((resolve, reject) => {
        try {
          const unwatch = watch(
            () => store.state.qcssoSdk, 
            (sdk) => {
              if (sdk && sdk?.request)
              {
                const result = sdk.request(config);
                resolve(result);
              }
              else
              {
                reject('[api] QCSSO SDK is not defined');
              }
              unwatch();
            }
          );
        } catch (err) {
          reject(err);
        }
      });
    }
    else
    {
      return store.state.qcssoSdk.request(config);
    }
  }

  useData(res = {}) {
    if (res.data !== undefined) return res.data;

    return res;
  }
}